import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';


gsap.registerPlugin(SplitText, ScrollTrigger, DrawSVGPlugin);

let isWorking = false;
let hasEntered = false;

const stopAutoplay = swiper => {
	console.log('sto fermando lo slider');
	const sliderWrapper = document.querySelector('.hero .wrapper-cards .swiper-wrapper');
	isWorking = false;
	hasEntered = true;
	gsap.set(sliderWrapper, {transitionDuration : 0});
	gsap.set(sliderWrapper, {x: swiper.getTranslate() })
}

const disabledButton = swiper => {
	const prevButton = document.querySelector('.hero .swiper-button-prev');

	if (swiper.realIndex == 0) {
		prevButton.classList.add('disabled');
	}else if (swiper.realIndex != 0 && prevButton.classList.contains('disabled') ){
		prevButton.classList.remove('disabled');
	}

}

const restartAutoplay = swiper => {
	if (isWorking) return;
	isWorking = true;

	console.log('sta ripartendo lo slider');
	
	const sliderWrapper = document.querySelector('.hero .wrapper-cards .swiper-wrapper');
	const slide = swiper.slides[0];
	const slideWidth = parseFloat(getComputedStyle(slide).width) + parseFloat(getComputedStyle(slide).marginRight);
	const remainingTranslate = - (swiper.translate - swiper.getTranslate());
	const valueTiming = remainingTranslate * swiper.params.speed / slideWidth

	gsap.set(sliderWrapper, {transitionDuration : valueTiming});
	gsap.set(sliderWrapper, {x: swiper.translate})

	setTimeout(() => { 
		swiper.autoplay.start();
		isWorking = false;
		hasEntered = false;
	}, valueTiming)
}

const translateSlide = (swiper, direction) => {

	const sliderWrapper = document.querySelector('.hero .wrapper-cards .swiper-wrapper');
	const slide = swiper.slides[0];
	const slideWidth = parseFloat(getComputedStyle(slide).width) + parseFloat(getComputedStyle(slide).marginRight);

	gsap.set(sliderWrapper, {transitionDuration: 300});

	if (direction == "next") {
	gsap.to(sliderWrapper, {x: swiper.translate});
	} else if (direction == "prev" && swiper.realIndex != 0) {
	gsap.to(sliderWrapper, {x: swiper.getTranslate() + slideWidth, onComplete: () => swiper.slideTo(swiper.activeIndex - 1)});
	}

	setTimeout(() => {
		swiper.autoplay.start();
		isWorking = false;
		hasEntered = false;

	}, 500);
	
	// disabledButton(swiper);
}


// USCITA DALLA SPLASH PAGE: TITLE + CIRCLE EXPAND 
const homeEnter = (data) => {

	const main = data.next.container;
	const overlay = document.querySelector('.transition-overlay');
	const header = document.querySelector('.main-header');

	// const title = main.querySelector(".hero .hero-title");
	// const intro = main.querySelector(".hero .intro");
	// const slider = main.querySelector('.hero .wrapper-cards');
	// const dates = [...main.querySelectorAll('.hero .date')];
	// const textSplit = SplitText.create(intro, {type: "words", autoSplit: true, mask: "words", aria: "none" });

	const tl = gsap.timeline({
		defaults: {force3D: true},
		// onStart: () => {
		// 	initHpSlider(data);
		// },
		// onComplete: () => {
		// 	titleSplit.revert();
		// 	textSplit.revert();
		// }
	});

	tl
		.set([overlay], {autoAlpha: 0}, 0)
		.to(header, {y: 0, duration: 1}, 0)
		// .to([title, intro, slider, dates], {autoAlpha: 1, duration: 1}, 0.5)
		// .from(titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 2, stagger: 0.1 }, "<15%")
		.set(document.body, {clearProps: 'all'}, ">")

	return tl;
}


const buySection = (data) => {
	const main = data.next.container;
	const buySection = main.querySelector(".buy");
	const title = buySection.querySelector(".section-title");
	const buyBtn = buySection.querySelector(".fp-btn-ter");	
	const text = buySection.querySelector(".more-info");
	const posterImg = buySection.querySelector(".poster-img");


	gsap.set([title, text, buyBtn, posterImg], {autoAlpha: 0});

	setTimeout(() => {
		const titleSplit = SplitText.create(title, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });
		const textSplit = SplitText.create(text, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });

		const tl = gsap.timeline({ 
			defaults: {ease: "expo.out", force3D: true},
			onComplete: () => {
				titleSplit.revert();
				textSplit.revert();
			}
		});

		tl
			.set([title, text], {autoAlpha: 1}, 0)
			.from(titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 2, stagger: 0.1 }, 0)
			.to([buyBtn], {autoAlpha: 1, duration: 2 }, "<10%")
			.from(textSplit.lines, { yPercent: 100, autoAlpha: 0, duration: 1.4, stagger: 0.1 }, "<5%")
			.to(posterImg, {autoAlpha: 1, duration: 1.2, ease: "power3.inOut"}, "<");
	}, 100);
}


// USCITA DALL'HOMEPAGE PAGE: FADE OUT
const homeExit = (data, type = null) => {

	const main = data.current.container;
	const header = document.querySelector('.main-header');
	const overlay = document.querySelector('.transition-overlay');
	const footer = main.querySelector('.main-footer');
	const tl = gsap.timeline({ defaults: {ease: "expo.out", force3D: true} });

	tl
		.set(document.body, {overflow: 'hidden'})
		.to(header, {yPercent: -100, duration: 1}, 0)
		.to([main.querySelectorAll('section'), footer], {autoAlpha: 0, duration: 0.5}, 0);

		if (type !== 'self') {
			tl
				.set(overlay, {"--main-bgk" : "#E30613", "--in-gradient" : "#E30613", "--out-gradient" : "#E30613", top: '0', left: '0', transform: 'none', position: 'absolute', '--width': '100vw', '--height': '100vh'}, 0.2)
				.to(overlay, {autoAlpha: 1, duration: 0.8}, 0.3);
		}

	tl
		.add(() => {
			window.scrollTo(0, 0);
			document.body.classList.remove('hide-layer');
			document.body.style.overflow = 'auto';
		}, 0.5)
		.set(document.body, {clearProps: 'all'}, ">")
		if (type !== 'self') {
			tl.set(overlay, {clearProps: 'all'}, ">")
		}
		
	return tl;
}

const initHpSlider = (data) => {
	const main = data.next.container;
	const boxes = [...main.querySelectorAll(".box")];
	const hero = main.querySelector(".hero");
	const colorMap = {};
	const slider = document.querySelector('.hero .wrapper-cards');
	// 	const nextButton = document.querySelector('.welfareSection .swiper-button-next');
	// const prevButton = document.querySelector('.welfareSection .swiper-button-prev');

	const slides = gsap.utils.toArray(".hero .wrapper-cards .box");

	// Costruisci la mappa dei colori
	boxes.forEach((box, index) => {
		const color = box.dataset.color;
		if (color) {
			colorMap[index] = color;
		}
	});

	// Trova tutti gli indici con colori
	const coloredIndices = Object.keys(colorMap).map(Number);
	const totalSections = coloredIndices.length;
	const mainColor = main.dataset.color;
	
	// Crea la timeline del gradiente con ease ottimizzato
	const gradientTl = gsap.timeline({ 
		paused: true,
		repeat: -1,
		defaults: { ease: "none" }
	});
	

	for (let i = 0; i < totalSections; i++) {
		const isLast = i === totalSections - 1;
		const currentColor = colorMap[coloredIndices[i]];
		const nextColor = isLast ? mainColor : colorMap[coloredIndices[i + 1]];

		console.log(`Sezione ${i}: colore corrente ${currentColor}, colore successivo ${nextColor}`);

		gradientTl
			.to(hero, {
				'--gradient-end': nextColor,
				duration: 10
			}, ">")
			.to(hero, {
				'--end-position': 0,
				'--start-position': -100,
				'--gradient-start': nextColor,
				duration: 40
			}, ">")
			.set(hero, {
				'--end-position': 300,
				'--start-position': 0,
			}, ">" + 20);
			
	}

	const HpSlider = new Swiper(".wrapper-cards", {
		modules: [Autoplay, Navigation],
		speed: 5000,
		slidesPerView: 3.2,
		centeredSlides: false,
		spaceBetween: 16,
		grabCursor: true,
		allowTouchMove: false,
		loop: true,
		breakpoints: {
			600: {
				spaceBetween: 24,
				slidesPerView: 4.3,
			},
			900: {
				spaceBetween: 24,
				slidesPerView: 6.3,
			},
			1360: {
				spaceBetween: 24,
				slidesPerView: 7.8,
			}
		},
		autoplay: {
			delay: 0,
			disableOnInteraction: true,
		},
		on: {
			init: function() {
				gsap.set(slider, { height: slides[0].offsetHeight });
			},
			afterInit: function() {
				
				setTimeout(() => {
					// stopAutoplay(HpSlider);

					// gsap.to({}, {duration: 50, onUpdate: function() {
					// 	gradientTl.progress(this.progress());
					// }});

					// gradientTl.play();
				}, 1);
			}
		}
	});

	slider.addEventListener('mouseenter', () => {
		if (document.body.classList.contains('no-scroll') || window.innerWidth < 600) return;
		stopAutoplay(HpSlider);
	})


	slider.addEventListener('mousemove', () => {
		if (document.body.classList.contains('no-scroll') || hasEntered || window.innerWidth < 600) return;
		stopAutoplay(HpSlider);
	})


	slider.addEventListener('mouseleave', () => {
		if (document.body.classList.contains('no-scroll') || window.innerWidth < 600) return;
		restartAutoplay(HpSlider);
	})


	HpSlider.on('touchStart', () => {
		if (window.innerWidth > 600) return;
		stopAutoplay(HpSlider);
	})


	HpSlider.on('touchEnd', () => {
		if (window.innerWidth > 600) return;
		restartAutoplay(HpSlider);
	})

	// Crea timeline di espansione per ogni box
	let activeBox; // traccia quale box è aperto
	let autoplayStopped = false; // traccia se l'autoplay è già fermo
	
	slides.forEach((box, index) => {
		// Ottieni l'altezza standard per ogni box individualmente
		const boxStandardHeight = box.offsetHeight;
		
		// Crea animazione per ogni box
		const animation = gsap.timeline({ 
			paused: true,
			onStart: () => {
				box.classList.add("expand");
			},
			onReverseComplete: () => {
				box.classList.remove("expand");
				
				// Se questo era l'activeBox e non ci sono altri box in hover, riavvia l'autoplay
				if (box === activeBox) {
					activeBox = null;
					
					// Controlla se qualche box è ancora in hover
					const anyBoxHovered = slides.some(b => b.matches(':hover'));
					
					if (!anyBoxHovered) {
						restartAutoplay(HpSlider);
						autoplayStopped = false;
					}
				}
			}
		});
		
		// Usa fromTo per essere esplicito sui valori di partenza e arrivo
		animation.fromTo(box, 
			{ height: boxStandardHeight },
			{
				height: boxStandardHeight * 2,
				duration: 0.4,
				ease: "power2.out"
			}
		);
		
		// Assegna la timeline al box
		box.animation = animation;
		
		// Mouseenter: espandi questo box
		box.addEventListener("mouseenter", function(e) {
			if (window.innerWidth < 600) return;
			e.preventDefault();
			
			// Ferma l'autoplay solo se non è già stato fermato
			if (!autoplayStopped) {
				stopAutoplay(HpSlider);
				autoplayStopped = true;
			}
			
			if (activeBox) {
				// Chiudi il box attivo reversando l'animazione
				activeBox.animation.reverse();
			}

			console.log('sto espandendo il box');
			
			box.animation.play();
			activeBox = box;
		});
		
		// Mouseleave: contrai questo box
		box.addEventListener("mouseleave", function(e) {
			if (window.innerWidth < 600) return;
			e.preventDefault();
			e.stopPropagation();
			
			// L'autoplay verrà riavviato in onReverseComplete dopo che l'animazione è completata
			box.animation.reverse();
		});
	});







	// nextButton.addEventListener('click', () => {
	// 	stopAutoplay(welfareSwiper);
	// 	translateSlide(welfareSwiper,'next');
	// })

	// prevButton.addEventListener('click',() => {
	// 	stopAutoplay(welfareSwiper);
	// 	translateSlide(welfareSwiper,'prev');
	// })


// 	// Inizializza il loop infinito
// 	const loop = horizontalLoop(boxes, {
// 		paused: true, 
// 		draggable: false,
// 		onChange: (element, index) => {
// 			if (activeElement) activeElement.classList.remove("active");
// 			element.classList.add("active");
// 			activeElement = element;
// 		}
// 	});

// 	// Aggiungi eventi per tracciare il drag e l'inerzia
// 	if (loop.draggable) {
// 		const originalOnPress = loop.draggable.vars.onPress;
// 		const originalOnThrowComplete = loop.draggable.vars.onThrowComplete;
// 		const originalOnDragEnd = loop.draggable.vars.onDragEnd;

// 		loop.draggable.vars.onPress = function() {
// 			console.log("Throw started");
// 			isDragging = true;
// 			if (originalOnPress) originalOnPress.call(this);
// 		};

// 		loop.draggable.vars.onThrowComplete = function() {
// 			console.log("Throw complete");
// 			isDragging = false;
// 			if (originalOnThrowComplete) originalOnThrowComplete.call(this);
// 		};

// 		loop.draggable.vars.onDragEnd = function() {
// 			// Se non c'è throw, il drag è finito
// 			if (!this.isThrowing) {
// 				console.log("Throw complete");
// 				isDragging = false;
// 			}
// 			if (originalOnDragEnd) originalOnDragEnd.call(this);
// 		};
// 	}

// 	// Sincronizzazione ottimizzata: aggiorna solo se il progress è cambiato
// 	const syncTimelines = () => {
// 		const loopProgress = loop.progress();
// 		if (Math.abs(loopProgress - lastProgress) > 0.001) {
// 			gradientTl.progress(loopProgress);
// 			lastProgress = loopProgress;
// 		}
// 	};
	
// 	gsap.ticker.add(syncTimelines);
// let expanders = gsap.utils.toArray(".box")
// let isAnimating = false;


// const animationExpande = (item) => {
// 	console.log('sono dentro animationExpande');
	
// 	const tl = gsap.timeline({
// 		paused: true,
// 		onComplete: () => {
// 			isAnimating = false;
// 		}
// 	});
	
// 	// Ottieni i valori correnti
// 	const currentFlexBasis = gsap.getProperty(item, "flexBasis");
// 	const currentXPercent = gsap.getProperty(item, "xPercent");
// 	const currentWidth = gsap.getProperty(item, "width");
	
// 	// Calcola lo spostamento assoluto in pixel (indipendente dalla larghezza)
// 	// xPercent è relativo alla larghezza, quindi moltiplico per width e divido per 100
// 	const absoluteOffsetPx = (currentXPercent * currentWidth) / 100;
	
// 	// Calcola la nuova larghezza
// 	const newFlexBasis = currentFlexBasis * 2;
// 	const newWidth = currentWidth * 2;
	
// 	// Calcola il nuovo xPercent per mantenere lo stesso offset assoluto
// 	// newXPercent = (offsetInPixel / newWidth) * 100
// 	const newXPercent = (absoluteOffsetPx / newWidth) * 100;
	
// 	console.log('Current flexBasis:', currentFlexBasis);
// 	console.log('Current width:', currentWidth);
// 	console.log('Current xPercent:', currentXPercent);
// 	console.log('Absolute offset (px):', absoluteOffsetPx);
// 	console.log('New flexBasis:', newFlexBasis);
// 	console.log('New width:', newWidth);
// 	console.log('New xPercent:', newXPercent);
	
// 	tl.to(item, {
// 		flex: `0 0 ${newFlexBasis}%`, 
// 		xPercent: newXPercent,
// 		duration: 0.4, 
// 		overwrite: "auto", 
// 		ease: "power2.out"
// 	}, 0)

// 	return tl;
// }


// const animationContract = (item) => {
// 	console.log('sono dentro animationContract');
	
// 	const tl = gsap.timeline({paused:true});
// 	const slateWidth = gsap.getProperty(item, "flexBasis");
// 	const testValue = gsap.getProperty(item, "xPercent");

// 	console.log(slateWidth);
// 	console.log(slateWidth / 2);
// 	console.log(testValue * 2);

// 	tl
// 		.to(item, {flex:`0 0 ${slateWidth / 2}`, duration: 0.4, xPercent: (testValue * 2), overwrite: "auto"}, 0)

// 	return tl;
// }


// expanders.forEach(expander =>{

//   expander.addEventListener("mouseenter", () => {

// 		loop.pause();
// 		if (document.querySelector(".box.expanded") || isAnimating) return;

// 		console.log(expander);
		
// 		// Aggiungi classe active e flag di animazione
// 		expander.classList.add("expanded");
// 		isAnimating = true;
	
		
//     animationExpande(expander).play()
//   })


//   //close this expander by reversing the animation
//   expander.addEventListener("mouseleave", event => {

// 		// Ignora mouseleave se l'animazione è in corso o l'elemento non è espanso
// 		if (!expander.classList.contains("expanded") || isAnimating) return;

//     event.stopPropagation()
//     animationContract(expander).play()
// 		expander.classList.remove("expanded");
//   })
// })

}

export {homeEnter, homeExit, buySection};